/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedArrowRight = createReactComponent(
  "square-rounded-arrow-right",
  "IconSquareRoundedArrowRight",
  [
    ["path", { d: "M12 16l4 -4l-4 -4", key: "svg-0" }],
    ["path", { d: "M8 12h8", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareRoundedArrowRight as default };
//# sourceMappingURL=IconSquareRoundedArrowRight.js.map
